$(function(){
    $.fn.myPreloader=function(options,timeHander){
        var settings;
        var main=this; 
        var methods = {
            trigger: function(count){
                var obj=$(this),data=obj.data("myPreloader");
                count= intval(count) || 1;
                if(typeof data!=="undefined"){
                    if(typeof data.was_init!=="undefined"){
                        obj.trigger("addToLoader",count);
                    }
                    else{
                        data.beforeInit+=count;
                        obj.data("myPreloader",data);
                    }
                }
                else{
                    data={beforeInit:count};
                    obj.data("myPreloader",data);
                }
            }
        };
        
        function init(obj){
            var items=[],i,count=0,count_max,anim_obj;
            items=copyArray(settings.urlArr);
            obj.find('div,img').each(function() {
                var url = "";
                if ($(this).css('background-image').indexOf('none') == -1 && $(this).css('background-image').indexOf('-gradient') == -1) {
                        url = $(this).css('background-image');
                        if(url.indexOf('url') != -1) {
                                var temp = url.match(/url\((.*?)\)/);
                                url = temp[1].replace(/\"/g, '');
                        }
                } else if ($(this).get(0).nodeName.toLowerCase() == 'img' && typeof($(this).attr('src')) != 'undefined') {
                        url = $(this).attr('src');
                }
                if (url.length > 0 && !in_array(url,items)) {
                    items.push(url);
                }
            });
            count_max=items.length+settings.addToLoader-settings.beforeInit;
            prepareView(obj);
            obj.one("hidePreloder",function(){
                count=count_max;
                afterLoad(1);
            });
            if(settings.addToLoader){
                obj.on("addToLoader",function(e,to_add){
                    afterLoad(Math.max(1,intval(to_add)));
                });
            }
            anim_obj=obj.find(">.myPreloader");
            
            for(i in items){
                loadImg(items[i]);
            }
            function loadImg(url) {
                $('<img/>').one("one load error",function() {
                    afterLoad(1);
                }).attr('src', url);
            }
            function afterLoad(to_add){
                count+=to_add;
                main.trigger("myPreloaderLoad",count,count_max);
                
                if(count>=count_max){
                    
                    var i;
                    for(i in settings.timeIndexArr){
                        timeHander.clear(settings.timeIndexArr[i]);
                    }
                    
                    
                    obj.trigger("myPreloaderEnd").find(">.myPreloader").remove();
                    
                    obj.off("addToLoader");
                    obj.data("myPreloader",{"timeIndexArr":copyObj(settings.timeIndexArr)});
                }
            }
        }
        
        function prepareView(obj){
            function exe(obj){
                var html;
                html=
                '<div class="myPreloader">'+
                    '<canvas width="200" height="200"></canvas>'+
                '</div>';
                obj.prepend(html);
                var canv=obj.find(">.myPreloader>canvas");
                canv.attr({width:canv.width(),height:canv.height()});
                canv.one("was_loaded",function(){
                    canv.myAnimTiny("prepareLoader","heart",150);
                }).myAnimTiny({},timeHander,settings.timeIndexArr.anim);
                obj.trigger("myPreloaderInit",obj.find(">.myPreloader"));
            }
            if(settings.waitMili<1){
                exe(obj);
            }
            else{
                timeHander.setOne(settings.timeIndexArr.main,function(){},settings.waitMili,function(){
                   exe(obj); 
                });
            }
        }
        
        var arg =Array.prototype.slice.call(arguments,1);
        return this.each(function() {
            if(typeof options === 'object' || !options){ 
                var th = $(this);
                settings = th.data("myPreloader");  
                if(typeof settings=="undefined" || !settings){
                    settings={
                        "timeIndexArr":{main:timeHander.getNewIndex(),anim:timeHander.getNewIndex()}
                    };
                }
                
                settings = $.extend( {
                    addToLoader:0,
                    beforeInit:0,
                    urlArr:[],
                    waitMili:50,
                }, settings, options);
                settings.was_init=1;
                init(th);  
                th.data("myPreloader",settings);
                
            }
            else if(typeof methods[options]=="function"){
                return methods[options].apply(main,arg);
            }
        });
    };
});
